export default __webpack_public_path__ + "static/media/erika.10db789d.svg";